import { Link } from "react-router-dom";
import { PackageX } from "lucide-react";

export function ErrorState({
  title = "Halaman tidak ditemukan",
  description = "Halaman yang kamu cari tidak ada atau sudah dipindahkan.",
  actionTo = "/",
  actionLabel = "Kembali ke Beranda",
}) {
  return (
    <div
      data-testid="error-state"
      className="flex flex-col items-center justify-center px-6 py-24 text-center"
    >
      <div className="flex h-16 w-16 items-center justify-center rounded-full bg-nm-surface2">
        <PackageX className="h-8 w-8 text-nm-red" />
      </div>
      <h1 className="mt-5 text-2xl font-bold text-nm-text">{title}</h1>
      <p className="mt-2 max-w-md text-nm-muted">{description}</p>
      <Link
        to={actionTo}
        data-testid="error-state-action"
        className="mt-6 inline-flex h-11 items-center justify-center rounded-lg bg-nm-red px-6 font-semibold text-white transition-colors hover:bg-nm-red-hover"
      >
        {actionLabel}
      </Link>
    </div>
  );
}
